import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TalkTherapy from "./pages/TalkTherapy";
import MassageTherapy from "./pages/MassageTherapy";
import SubstanceAddiction from "./pages/SubstanceAddiction";
import Psychology from "./pages/Psychology";
import Coaching from "./pages/Coaching";
import Staff from "./pages/Staff";
import Locations from "./pages/Locations";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Join from "./pages/Join";
import Charities from "./pages/Charities";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/locations" element = {<Locations />} />
        <Route path="/charities" element={<Charities />} />
        <Route path="/talktherapy" element={<TalkTherapy />} />
        <Route path="/massagetherapy" element={<MassageTherapy />} />
        <Route path="/substanceaddiction" element={<SubstanceAddiction />} />
        <Route path="/psychology" element={<Psychology />} />
        <Route path ="/coaching" element={<Coaching />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/join" element={<Join />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;